import React from "react";
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';

import AdditionalMaterialTab from "./additionalMaterial/AdditionalMaterialTab";
import HelperAssignments from "./helperAssignments/HelperAssignmentsTab";
import DriverPendingBalancesTab from "./driverPendingBalances/DriverPendingBalancesTab";
import LocationPendingPayment from "./locationPendingPayment/LocationPendingPaymentTab";
import ExtraLineItemTab from "./extraLineItem/ExtraLineItemTab";

class RouteOtherData extends React.Component {
  componentWillMount() {
    this.setState({ open: true });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ open: nextProps.open });
  }

  closeModal = () => {
    this.setState({ open: false });
  };

  renderNoResultsFound = () => {
    const { i18n } = this.props;
    return (
      <div className="noResultsFound">
        {i18n.getResourcesByKey("Greenmile.Grid.NoResult")}
      </div>
    );
  };

  render() {
    if (!this.state.open) {
      return null;
    }

    const { route, i18n } = this.props;
    const { attributes } = route;

    const {
      additionalMaterials,
      holderMaterials,
      helperAssignments,
      driverPendingBalances,
      locationPendingPayments,
      extraLineItems
    } = attributes;

    return (
      <div id="routeData">
        <div className="routeDataModalContainer">
          <div
            className="closeModalWindow routeDataCloseModal"
            onClick={this.closeModal}
          />
          <Tabs>
            <TabList>
              <Tab>
                <span>{i18n.getResourcesByKey(
                "route.data.title.additionalMaterial"
              )}</span></Tab>
              <Tab><span>{i18n.getResourcesByKey(
                "route.data.title.helperAssignments"
              )}</span></Tab>
              <Tab><span>{i18n.getResourcesByKey(
                "route.data.title.driverPendingBalances"
              )}</span></Tab>
              <Tab><span>{i18n.getResourcesByKey(
                "route.data.title.locationPendingPayment"
              )}</span></Tab>
              <Tab><span>{i18n.getResourcesByKey(
                "route.data.title.extraLineItem"
              )}</span></Tab>
            </TabList>
            <TabPanel>
              <AdditionalMaterialTab
                addMatArray={additionalMaterials}
                holdMatArray={holderMaterials}
                i18n={i18n}
                renderNoResultsFound={this.renderNoResultsFound}
                closeModal={this.closeModal}
              />
            </TabPanel>
            <TabPanel >
              <HelperAssignments
                helpersArray={helperAssignments}
                i18n={i18n}
                renderNoResultsFound={this.renderNoResultsFound}
                closeModal={this.closeModal}
              />
            </TabPanel>
            <TabPanel>
              <DriverPendingBalancesTab
                driverPendingBalanceArray={driverPendingBalances}
                i18n={i18n}
                renderNoResultsFound={this.renderNoResultsFound}
                closeModal={this.closeModal}
              />
            </TabPanel>
            <TabPanel>
              <LocationPendingPayment
                locationPendingPaymentArray={locationPendingPayments}
                i18n={i18n}
                renderNoResultsFound={this.renderNoResultsFound}
                closeModal={this.closeModal}
              />
            </TabPanel>
            <TabPanel>
              <ExtraLineItemTab
                extraLineItemArray={extraLineItems}
                i18n={i18n}
                renderNoResultsFound={this.renderNoResultsFound}
                closeModal={this.closeModal}
              />
            </TabPanel>

          </Tabs>
        </div>
      </div>
    );
  }
}

export default RouteOtherData;
